import { Children, Fragment, isValidElement, ReactElement, ReactNode } from 'react'

interface StackWithDividersProps {
  children: ReactNode[]
  divider: ReactElement
}

export const StackWithDividers = ({ children, divider }: StackWithDividersProps): ReactElement => {
  const validChildren = Children.toArray(children).filter(isValidElement)

  return (
    <>
      {validChildren.map((child, index) => (
        <Fragment key={index}>
          {child}
          {index < validChildren.length - 1 && divider}
        </Fragment>
      ))}
    </>
  )
}
